import React, { useState, useEffect } from 'react';
import '../assets/styles/CadastroProdutor.css';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export default function CadastroFamilia() {
  const [familia, setFamilia] = useState({
    nome_responsavel: '',
    povoado_id: '',
    latitude: '',
    longitude: '',
    tipo_producao: ''
  });
  const [familias, setFamilias] = useState([]);
  const [povoados, setPovoados] = useState([]);
  const [editId, setEditId] = useState(null);
  const [mensagem, setMensagem] = useState(null);
  const [carregandoLocalizacao, setCarregandoLocalizacao] = useState(false);

  // Buscar famílias da API ao carregar
  useEffect(() => {
    fetch(`${API_BASE_URL}/familias/`)
      .then(res => res.json())
      .then(data => {
        console.log('Dados de famílias recebidos:', data);
        setFamilias(Array.isArray(data.productId) ? data.productId : []);
      })
      .catch(() => setMensagem('❌ Erro ao buscar famílias.'));
  }, []);

  // Buscar povoados da API ao carregar
  useEffect(() => {
    fetch(`${API_BASE_URL}/povoados/`)
      .then(res => res.json())
      .then(data => {
        console.log('Dados de povoados recebidos:', data);
        setPovoados(Array.isArray(data.productId) ? data.productId : []);
      })
      .catch(() => setMensagem('❌ Erro ao buscar povoados.'));
  }, []);

  // Função para obter o nome do povoado pelo ID
  const getNomePovoado = (povoado_id) => {
    if (!povoado_id) return '-';
    const povoado = povoados.find(p => p.id === povoado_id || p.id === parseInt(povoado_id));
    return povoado ? povoado.nome : 'Povoado não encontrado';
  };

  // Função para editar família
  const handleEdit = (id) => {
    if (editId === id) {
      // Se já estiver no modo de edição, limpa os inputs e volta ao modo de cadastro
      setFamilia({ nome_responsavel: '', povoado_id: '', latitude: '', longitude: '', tipo_producao: '' });
      setEditId(null);
      setMensagem(null);
    } else {
      const f = familias.find(f => f.id === id);
      if (f) {
        setFamilia({ 
          nome_responsavel: f.nome_responsavel || '',
          povoado_id: f.povoado_id || '',
          latitude: f.latitude || '',
          longitude: f.longitude || '',
          tipo_producao: f.tipo_producao || ''
        });
        setEditId(id);
        setMensagem(null);
        console.log('Editando família:', f);
      } else {
        setMensagem('❌ Família não encontrada para edição.');
      }
    }
  };

  // Função para deletar família via API
  const handleDelete = async (id) => {
    if (!window.confirm('Tem certeza que deseja excluir esta família?')) {
      return;
    }

    try {
      console.log('Deletando família com ID:', id);
      const res = await fetch(`${API_BASE_URL}/familias/delete`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id })
      });
      
      console.log('Resposta da API delete:', res.status);
      
      if (res.ok) {
        setFamilias(familias.filter(f => f.id !== id));
        setMensagem('✅ Família removida com sucesso!');
        if (editId === id) {
          setEditId(null);
          setFamilia({ nome_responsavel: '', povoado_id: '', latitude: '', longitude: '', tipo_producao: '' });
        }
      } else {
        const errorData = await res.text();
        console.error('Erro ao deletar:', errorData);
        setMensagem('❌ Erro ao remover família.');
      }
    } catch (error) {
      console.error('Erro ao deletar família:', error);
      setMensagem('❌ Erro ao remover família.');
    }
  };

  const handleChange = e => {
    let value = e.target.value;
    
    // Se for um campo de coordenada, limpar caracteres especiais e converter
    if (e.target.name === 'latitude' || e.target.name === 'longitude') {
      // Remove símbolos especiais como ‑ (hífen em dash), °, espaços extras
      value = value.replace(/[‑−°\s]/g, ''); // Remove hífen especial, graus, espaços
      value = value.replace(/[^\d.,-]/g, ''); // Mantém apenas números, ponto, vírgula e hífen normal
      value = value.replace(/,/g, '.'); // Substitui vírgula por ponto
      
      // Se começar com hífen, manter o sinal negativo
      if (e.target.value.startsWith('‑') || e.target.value.startsWith('−') || e.target.value.startsWith('-')) {
        value = '-' + value.replace(/^-+/, '');
      }
    }
    
    setFamilia({ ...familia, [e.target.name]: value });
  };

  // Função para validar coordenadas
  const validarCoordenadas = (lat, lng) => {
    if (!lat && !lng) return null; // Coordenadas são opcionais
    
    const latitude = parseFloat(lat);
    const longitude = parseFloat(lng);
    
    if (lat && (isNaN(latitude) || latitude < -90 || latitude > 90)) {
      return 'Latitude deve estar entre -90 e 90 graus';
    }
    
    if (lng && (isNaN(longitude) || longitude < -180 || longitude > 180)) {
      return 'Longitude deve estar entre -180 e 180 graus';
    }
    
    return null;
  };

  // Ao enviar o formulário
  const handleSubmit = async e => {
    e.preventDefault();
    
    // Validar coordenadas antes de enviar
    const erroValidacao = validarCoordenadas(familia.latitude, familia.longitude);
    if (erroValidacao) {
      setMensagem(`❌ ${erroValidacao}`);
      return;
    }
    
    if (editId) {
      // Atualizar família existente
      try {
        // Recupera a data_cadastro original
        const familiaAntiga = familias.find(f => f.id === editId);
        const dataCadastroOriginal = familiaAntiga && familiaAntiga.data_cadastro ? familiaAntiga.data_cadastro : undefined;
        console.log('Atualizando família:', { id: editId, ...familia });
        const res = await fetch(`${API_BASE_URL}/familias/update`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: editId,
            nome_responsavel: familia.nome_responsavel,
            povoado_id: familia.povoado_id,
            latitude: familia.latitude,
            longitude: familia.longitude,
            tipo_producao: familia.tipo_producao,
            data_cadastro: dataCadastroOriginal
          })
        });
        
        console.log('Resposta da atualização:', res.status);
        
        if (res.ok) {
          // Atualizar a família na lista local
          const familiaAtualizada = {
            id: editId,
            nome_responsavel: familia.nome_responsavel,
            povoado_id: familia.povoado_id,
            latitude: familia.latitude,
            longitude: familia.longitude,
            tipo_producao: familia.tipo_producao,
            data_cadastro: dataCadastroOriginal
          };
          setFamilias(familias.map(f => (f.id === editId ? familiaAtualizada : f)));
          setMensagem('✅ Família atualizada com sucesso!');
          setEditId(null);
          setFamilia({ nome_responsavel: '', povoado_id: '', latitude: '', longitude: '', tipo_producao: '' });
        } else {
          const errorData = await res.text();
          console.error('Erro na atualização:', errorData);
          setMensagem('❌ Erro ao atualizar família.');
        }
      } catch (error) {
        console.error('Erro ao atualizar família:', error);
        setMensagem('❌ Erro ao atualizar família.');
      }
    } else {
      // Criar nova família
      try {
        console.log('Criando nova família:', familia);
        const res = await fetch(`${API_BASE_URL}/familias/add`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            nome_responsavel: familia.nome_responsavel,
            povoado_id: familia.povoado_id,
            latitude: familia.latitude,
            longitude: familia.longitude,
            tipo_producao: familia.tipo_producao
          })
        });
        
        console.log('Resposta da criação:', res.status);
        
        if (res.ok) {
          const result = await res.json();
          console.log('Resultado da criação:', result);
          
          // Buscar a família recém cadastrada pelo id retornado
          if (result && result.productId) {
            try {
              const resFamily = await fetch(`${API_BASE_URL}/familias/${result.productId}`);
              const familyData = await resFamily.json();
              console.log('Dados da família criada:', familyData);
              
              if (familyData && Array.isArray(familyData.familias) && familyData.familias.length > 0) {
                setFamilias([...familias, familyData.familias[0]]);
              } else {
                // Fallback: adicionar com os dados locais
                const novaFamilia = {
                  id: result.productId,
                  nome_responsavel: familia.nome_responsavel,
                  povoado_id: familia.povoado_id,
                  latitude: familia.latitude,
                  longitude: familia.longitude,
                  tipo_producao: familia.tipo_producao
                };
                setFamilias([...familias, novaFamilia]);
              }
            } catch (fetchError) {
              console.error('Erro ao buscar família criada:', fetchError);
              // Fallback: adicionar com os dados locais
              const novaFamilia = {
                id: result.productId,
                nome_responsavel: familia.nome_responsavel,
                povoado_id: familia.povoado_id,
                latitude: familia.latitude,
                longitude: familia.longitude,
                tipo_producao: familia.tipo_producao
              };
              setFamilias([...familias, novaFamilia]);
            }
          }
          setMensagem('✅ Família cadastrada com sucesso!');
          setFamilia({ nome_responsavel: '', povoado_id: '', latitude: '', longitude: '', tipo_producao: '' });
        } else {
          const errorData = await res.text();
          console.error('Erro na criação:', errorData);
          setMensagem('❌ Erro ao cadastrar família.');
        }
      } catch (error) {
        console.error('Erro ao cadastrar família:', error);
        setMensagem('❌ Erro ao cadastrar família.');
      }
    }
  };

  const obterLocalizacaoAtual = () => {
    setCarregandoLocalizacao(true);
    setMensagem(null);

    if (!navigator.geolocation) {
      setMensagem('Geolocalização não é suportada neste navegador.');
      setCarregandoLocalizacao(false);
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const latitude = position.coords.latitude.toFixed(6);
        const longitude = position.coords.longitude.toFixed(6);
        
        setFamilia(prev => ({
          ...prev,
          latitude: latitude,
          longitude: longitude
        }));
        
        setMensagem(`Localização capturada com sucesso! Precisão: ${position.coords.accuracy.toFixed(0)}m`);
        setCarregandoLocalizacao(false);
      },
      (error) => {
        let errorMessage = 'Erro ao obter localização: ';
        switch(error.code) {
          case error.PERMISSION_DENIED:
            errorMessage += 'Permissão negada pelo usuário.';
            break;
          case error.POSITION_UNAVAILABLE:
            errorMessage += 'Localização indisponível.';
            break;
          case error.TIMEOUT:
            errorMessage += 'Timeout na solicitação.';
            break;
          default:
            errorMessage += 'Erro desconhecido.';
            break;
        }
        setMensagem(errorMessage);
        setCarregandoLocalizacao(false);
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 60000
      }
    );
  };

  // ...existing code...

  return (
    <div className="cadastro-produtor-container">
      <h2>Cadastro de Família</h2>
      <div className="cadastro-form">
        <form onSubmit={handleSubmit} style={{marginBottom: 32}}>
          <fieldset>
            <legend>Dados da Família</legend>
            <label htmlFor="nome_responsavel">Nome do Responsável</label>
            <input id="nome_responsavel" name="nome_responsavel" value={familia.nome_responsavel} onChange={handleChange} required />
            <label htmlFor="tipo_producao">Tipo de Produção</label>
            <select id="tipo_producao" name="tipo_producao" value={familia.tipo_producao} onChange={handleChange} required>
              <option value="">Selecione</option>
              <option value="Comercial">Comercial</option>
              <option value="Subsistencia">Subsistência</option>
              <option value="Mista">Mista</option>
            </select>
            <label htmlFor="povoado_id">Povoado</label>
            <select id="povoado_id" name="povoado_id" value={familia.povoado_id} onChange={handleChange} required>
              <option value="">Selecione</option>
              {povoados.map(p => (
                <option key={p.id} value={p.id}>{p.nome}</option>
              ))}
            </select>
            <div style={{ display: 'flex', gap: '10px', marginBottom: '15px' }}>
              <div style={{ flex: 1 }}>
                <label htmlFor="latitude">Latitude (ex: -10.97157)</label>
                <input 
                  id="latitude" 
                  name="latitude" 
                  value={familia.latitude} 
                  onChange={handleChange} 
                  placeholder="-10.97157"
                  title="Digite a latitude no formato decimal (ex: -10.97157)"
                />
              </div>
              <div style={{ flex: 1 }}>
                <label htmlFor="longitude">Longitude (ex: -37.6340)</label>
                <input 
                  id="longitude" 
                  name="longitude" 
                  value={familia.longitude} 
                  onChange={handleChange} 
                  placeholder="-37.6340"
                  title="Digite a longitude no formato decimal (ex: -37.6340)"
                />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <label style={{ 
                  display: 'block',
                  fontWeight: '500',
                  marginBottom: '0.5rem',
                  color: '#212529',
                  visibility: 'hidden'
                }}>GPS</label>
                <button 
                  type="button" 
                  onClick={obterLocalizacaoAtual}
                  disabled={carregandoLocalizacao}
                  style={{
                    padding: '0.75rem 1rem',
                    backgroundColor: carregandoLocalizacao ? '#9ca3af' : '#10b981',
                    color: 'white',
                    border: 'none',
                    borderRadius: '0.375rem',
                    cursor: carregandoLocalizacao ? 'not-allowed' : 'pointer',
                    fontSize: '1rem',
                    whiteSpace: 'nowrap',
                    minWidth: '120px',
                    marginBottom: '1.2rem'
                  }}
                >
                  {carregandoLocalizacao ? '📍 Obtendo...' : '📍 Usar GPS'}
                </button>
              </div>
            </div>
          </fieldset>
          <button type="submit" className="btn-cadastrar">{editId ? 'Atualizar' : 'Cadastrar'}</button>
          {mensagem && <p className="mensagem-sucesso">{mensagem}</p>}
        </form>

        {/* Tabela de famílias cadastradas */}
        <div style={{width: '100%', background: '#fff', borderRadius: 8, boxShadow: '0 2px 8px #0001', border: '1px solid #e0e0e0', padding: 24, marginBottom: 32}}>
          <h3>Últimas 5 Famílias Cadastradas</h3>
          <p style={{margin: '0 0 12px 0', color: '#555', fontSize: 14}}>
            A tabela abaixo mostra apenas as 5 famílias mais recentemente cadastradas no sistema, considerando o maior ID como o mais novo.
          </p>
          <div style={{width: '100%', overflowX: 'auto'}}>
            <table style={{width: '100%', maxWidth: '100%', borderCollapse: 'collapse', tableLayout: 'auto'}}>
              <thead>
                <tr style={{ background: '#f7fafc' }}>
                  <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #e2e8f0' }}>Responsável</th>
                  <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #e2e8f0' }}>Povoado</th>
                  <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #e2e8f0' }}>Tipo de Produção</th>
                  <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #e2e8f0' }}>Latitude</th>
                  <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #e2e8f0' }}>Longitude</th>
                  <th style={{ padding: '12px', textAlign: 'center', borderBottom: '2px solid #e2e8f0' }}>Ações</th>
                </tr>
              </thead>
              <tbody>
                {familias
                  .slice()
                  .sort((a, b) => b.id - a.id)
                  .slice(0, 5)
                  .map(f => (
                    <tr key={f.id} style={{ background: '#fff' }}>
                      <td style={{ padding: '12px', borderBottom: '1px solid #e2e8f0' }}>{f.nome_responsavel}</td>
                      <td style={{ padding: '12px', borderBottom: '1px solid #e2e8f0' }}>{getNomePovoado(f.povoado_id)}</td>
                      <td style={{ padding: '12px', borderBottom: '1px solid #e2e8f0' }}>{f.tipo_producao}</td>
                      <td style={{ padding: '12px', borderBottom: '1px solid #e2e8f0' }}>{f.latitude || '-'}</td>
                      <td style={{ padding: '12px', borderBottom: '1px solid #e2e8f0' }}>{f.longitude || '-'}</td>
                      <td style={{ padding: '12px', textAlign: 'center', borderBottom: '1px solid #e2e8f0' }}>
                        <button onClick={() => handleEdit(f.id)} className="btn-acao" style={{marginRight: 8}}>Editar</button>
                        <button onClick={() => handleDelete(f.id)} className="btn-acao excluir">Excluir</button>
                      </td>
                    </tr>
                  ))}
                {familias.length === 0 && (
                  <tr><td colSpan={6} style={{textAlign: 'center', color: '#888'}}>Nenhuma família cadastrada.</td></tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        <div className="info-section">
          <h3>Informações sobre Famílias</h3>
          <div className="info-card">
            <h4>👨‍👩‍👧‍👦 Responsável Familiar</h4>
            <p>O responsável pela família será a referência principal para contatos e controle de produção agrícola da unidade familiar.</p>
          </div>
          <div className="info-card">
            <h4>📍 Coordenadas GPS</h4>
            <p>
              <strong>Formato correto:</strong> Use números decimais com ponto (ex: -10.97157, -37.6340)<br/>
              <strong>Latitude:</strong> Entre -90 e 90 graus (negativo = Sul, positivo = Norte)<br/>
              <strong>Longitude:</strong> Entre -180 e 180 graus (negativo = Oeste, positivo = Leste)<br/>
              <strong>Dica:</strong> Use o botão "📍 Usar GPS" para capturar automaticamente sua localização atual. A precisão GPS é melhor em áreas abertas!
            </p>
          </div>
          <div className="info-card">
            <h4>🌱 Tipo de Produção</h4>
            <p><strong>Comercial:</strong> Produção voltada para venda<br/>
            <strong>Subsistência:</strong> Produção para consumo próprio<br/>
            <strong>Mista:</strong> Combinação de ambas</p>
          </div>
        </div>
      </div>
    </div>
  );
}
